<script setup lang="ts">
import { computed, ref } from 'vue'

import { UiRouterView, useRoute } from '@/services/routing/index.ts'

import { FeatNavbar } from './components/FeatNavbar/index.ts'

const route = useRoute()

const navbarTitle = ref('')
const showsBackButton = computed(() => navbarTitle.value.toLowerCase().startsWith('#'))
</script>

<template>
  <div class="flex min-h-screen w-full flex-1 flex-col">
    <FeatNavbar
      :showBackBtn="showsBackButton"
      :title="navbarTitle"
    />
    <UiRouterView
      :key="route.fullPath"
      class="flex-1"
      @title-change="navbarTitle = $event"
    />
  </div>
</template>
